/* Source: https://levelup.gitconnected.com/polling-in-javascript-ab2d6378705a */

export const poll = async ({ fn, validate, interval, maxAttempts = null }) => {
    let attempts = 0;

    const executePoll = async (resolve, reject) => {
        const result = await fn();
        attempts++;

        if (validate(result)) {
            return resolve(result);
        } else if (maxAttempts && attempts === maxAttempts) {
            return reject(new Error('Exceeded max attempts'));
        } else {
            setTimeout(executePoll, interval, resolve, reject);
        }
    };

    return executePoll;
};
